import { useNavigate } from 'react-router-dom';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { Settings } from '@mui/icons-material';

import { AuthRole } from '@libs/types';
import { useAuth } from '@carcareers/hooks';
import { routes } from '@carcareers/utils';

export const AccountSettingsMenuItem = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const role = auth.session.user?.role as AuthRole;

  let settingsUrl = '';
  switch (role) {
    case AuthRole.ADMIN:
      settingsUrl = `/${routes.ADMIN_HOME}/${routes.ADMIN_SETTINGS}`;
      break;
    case AuthRole.EMPLOYER:
      settingsUrl = `/${routes.EMPLOYER_HOME}/${routes.EMPLOYER_SETTINGS}`;
      break;
    default:
      settingsUrl = `/${routes.JOBSEEKER_HOME}/${routes.JOBSEEKER_SETTINGS}`;
      break;
  }

  return (
    <MenuItem onClick={() => navigate(settingsUrl)}>
      <ListItemIcon>
        <Settings />
      </ListItemIcon>
      <ListItemText>Settings</ListItemText>
    </MenuItem>
  );
};

